var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.recipesLoaded)?_c('Recipes',{attrs:{"msg":"Most Recent"}}):_c('div',[_vm._v("Loading Recipes...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }